(() => {
  if (window.gridoneDealsPickerInstalled) return;
  window.gridoneDealsPickerInstalled = true;

  const priceInCents = input => {
    const raw = input.dataset.priceCents;
    if (raw && /^\d+$/.test(raw)) return Number(raw);
    const value = (input.dataset.price || '').replace(/(?:NOK|kr)/gi, '').replace(/[\s\u00a0\u202f]/g, '').replace(',', '.');
    return /^\d+(?:\.\d{1,2})?$/.test(value) ? Math.round(Number(value) * 100) : null;
  };
  const formatMoney = cents => new Intl.NumberFormat('nb-NO', {
    minimumFractionDigits: cents % 100 ? 2 : 0,
    maximumFractionDigits: 2
  }).format(cents / 100) + ' kr';

  function init() {
    document.querySelectorAll('[data-go-deals-picker]').forEach(root => {
      if (root.dataset.goPickerInitialized) return;
      root.dataset.goPickerInitialized = 'true';
      const inputs = Array.from(root.querySelectorAll('[data-go-deals-product]'));
      const list = root.querySelector('[data-go-deals-list]');
      const count = root.querySelector('[data-go-deals-count]');
      const empty = root.querySelector('[data-go-deals-empty]');
      const totalRow = root.querySelector('[data-go-deals-total-row]');
      const totalValue = root.querySelector('[data-go-deals-total]');
      const tax = root.querySelector('[data-go-deals-tax]');
      const continueButton = root.querySelector('[data-go-deals-continue]');
      const clearButton = root.querySelector('[data-go-deals-clear]');
      if (!inputs.length || !list || !continueButton) return;
      const storageKey = 'gridone-rigg-selection:' + (root.closest('[id^="shopify-section-"]')?.id || root.id);
      const success = document.querySelector('[data-go-equipment-panel] [data-go-success]');
      try {
        if (success) {
          sessionStorage.removeItem(storageKey);
          inputs.forEach(input => { input.checked = false; });
        }
        const stored = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (Array.isArray(stored)) inputs.forEach(input => { input.checked = stored.includes(input.value); });
      } catch (_) { /* Selection still works when browser storage is unavailable. */ }

      let inquiry = '';
      function update() {
        const selected = inputs.filter(input => input.checked);
        inputs.forEach(input => {
          const card = input.closest('.go-deals__card');
          card?.classList.toggle('is-selected', input.checked);
          const label = card?.querySelector('[data-go-deals-select-label]');
          if (label) label.textContent = input.checked ? root.dataset.selectedLabel : root.dataset.selectLabel;
        });
        list.replaceChildren();
        selected.forEach(input => {
          const item = document.createElement('li');
          const title = document.createElement('span');
          const price = document.createElement('span');
          title.textContent = input.dataset.title;
          price.textContent = input.dataset.price;
          item.append(title, price);
          list.append(item);
        });
        const prices = selected.map(priceInCents);
        const completePrices = selected.length > 0 && prices.every(Number.isSafeInteger);
        const total = completePrices ? prices.reduce((sum, price) => sum + price, 0) : null;
        count.textContent = String(selected.length);
        empty.hidden = selected.length > 0;
        list.hidden = selected.length === 0;
        totalRow.hidden = !completePrices;
        totalValue.textContent = completePrices ? formatMoney(total) : '';
        tax.hidden = selected.length === 0;
        continueButton.disabled = selected.length === 0;
        clearButton.hidden = selected.length === 0;
        const lines = selected.map(input => (input.dataset.inquiry || input.dataset.title) + (input.dataset.price ? ' (' + input.dataset.price + ')' : ''));
        if (completePrices) lines.push('', root.dataset.totalLabel + ': ' + formatMoney(total), root.dataset.taxLabel);
        inquiry = lines.join('\n');
        try { sessionStorage.setItem(storageKey, JSON.stringify(selected.map(input => input.value))); } catch (_) {}
        document.dispatchEvent(new CustomEvent('gridone:equipment-selection', {detail: {product: inquiry, focus: false}}));
      }
      inputs.forEach(input => input.addEventListener('change', update));
      clearButton.addEventListener('click', () => {
        inputs.forEach(input => { input.checked = false; });
        update();
        inputs[0]?.focus();
      });
      continueButton.addEventListener('click', () => {
        if (!inquiry) return;
        const panel = document.querySelector('[data-go-equipment-panel]');
        if (panel?.querySelector('input[type="email"]')) {
          document.dispatchEvent(new CustomEvent('gridone:equipment-selection', {detail: {product: inquiry, focus: true}}));
        } else {
          const url = new URL(root.dataset.inquiryUrl, location.origin);
          url.searchParams.set('interesse', 'equipment');
          url.searchParams.set('produkt', inquiry);
          url.hash = 'gridone-contact';
          location.assign(url.href);
        }
      });
      root.querySelectorAll('[data-go-deals-enhanced]').forEach(element => { element.hidden = false; });
      root.querySelectorAll('[data-go-deals-fallback]').forEach(element => { element.hidden = true; });
      update();
    });
  }
  // All deferred scripts, including the inquiry form handler, are ready at this point.
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
